import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b69f4fa6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "engagement-report-header" };
import EngagementReportFilters from './EngagementReportFilters/Filters.vue';
// libs;
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Header',
    setup(__props) {
        // components;
        const store = useStore();
        const updateSegment = selectedSegment => store.dispatch('engagementReport/setFetchSegmentOptions', selectedSegment);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('campaign.engagement-report.title')), 1),
                _createVNode(EngagementReportFilters, { onUpdateSegment: updateSegment })
            ]));
        };
    }
});
